import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import FlexparkenApp from "../components/parken/FlexparkenApp.vue";

export default function() {
  const element = document.querySelector("#vue-flexparken");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      new Vue({
        el: element,

        components: {
          FlexparkenApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(FlexparkenApp)
      })
    });
  }
}
